import { useState } from "react";
import { BadgeIndianRupee, CircleCheckBig, CircleX, X } from "lucide-react";
import { bookingStatus } from "../services/adminApiService/venueManagerApi/venueManagerApi";

export default function PaymentPopup({
  bookingId,
  onClose,
  refreshBookingDetails,
}) {
  const [remark, setRemark] = useState("");
  const [openRejectPopup, setOpenRejectPopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState({
    open: false,
    success: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  // APPROVE
  const handleApprove = async () => {
    try {
      setLoading(true);

      const response = await bookingStatus(bookingId, "Verified", remark);

      // booking API success popup first
      setStatusPopup({
        open: true,
        success: true,
        message: response?.message || "Booking Verified",
      });

      // refresh separately
      try {
        await refreshBookingDetails();
      } catch (refreshError) {
        console.error("Refresh error:", refreshError);
      }
    } catch (error) {
      console.error("Approve error:", error);

      setStatusPopup({
        open: true,
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  // REJECT
  const handleRejectConfirm = async () => {
    try {
      setLoading(true);

      const response = await bookingStatus(bookingId, "Rejected", remark);

      // show success popup first
      setStatusPopup({
        open: true,
        success: true,
        message: response?.message || "Booking rejected successfully",
      });

      setOpenRejectPopup(false);

      // refresh separately
      try {
        await refreshBookingDetails();
      } catch (refreshError) {
        console.error("Refresh error:", refreshError);
      }
    } catch (error) {
      console.error("Reject error:", error);

      setStatusPopup({
        open: true,
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="payment-loader-overlay">
          <div className="payment-loader-box">
            <div className="payment-spinner"></div>

            <p className="payment-loader-text">Processing...</p>
          </div>
        </div>
      )}
      {/* Main Payment Popup */}
      <div className="payment-modal-overlay">
        <div className="payment-modal">
          {/* Close */}
          <button className="payment-close-btn" onClick={onClose}>
            <X size={18} />
          </button>

          {/* Header */}
          <div className="payment-modal-header">
            <div className="payment-icon-wrapper">
              <BadgeIndianRupee size={22} color="#6B7280" />
            </div>

            <h3 className="payment-modal-title">Payment Received?</h3>
          </div>

          {/* Remark */}
          <div className="payment-modal-body">
            <label className="payment-label">Remark</label>

            <textarea
              className="payment-textarea"
              placeholder="Enter remark"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>

          {/* Footer */}
          <div className="payment-modal-actions">
            <button
              className="payment-btn payment-btn-reject"
              onClick={() => setOpenRejectPopup(true)}
            >
              Reject
            </button>

            <button
              className="payment-btn payment-btn-approve"
              onClick={handleApprove}
            >
              Approve
            </button>
          </div>
        </div>
      </div>

      {/* Reject Confirmation Popup */}
      {openRejectPopup && (
        <div className="payment-modal-overlay">
          <div className="reject-modal">
            {/* Header */}
            <div className="reject-header">
              <div className="reject-icon-wrapper">
                <CircleX size={20} color="#6B7280" />
              </div>

              <div>
                <h3 className="reject-title">Reject Ticket?</h3>

                <p className="reject-subtitle">
                  Are you sure you want to reject this ticket?
                </p>
              </div>
            </div>

            {/* Remark */}
            <div className="reject-body">
              <label className="payment-label">
                Remark <span style={{ color: "#DC2626" }}>*</span>
              </label>

              <textarea className="payment-textarea" value={remark} readOnly />
            </div>

            {/* Actions */}
            <div className="reject-actions">
              <button
                className="reject-cancel-btn"
                onClick={() => setOpenRejectPopup(false)}
              >
                Cancel
              </button>

              <button
                className="reject-confirm-btn"
                onClick={handleRejectConfirm}
              >
                Yes, Reject
              </button>
            </div>
          </div>
        </div>
      )}

      {statusPopup.open && (
        <div className="payment-modal-overlay">
          <div className="status-modal">
            <div className="status-modal-content">
              {/* ICON */}
              <div
                className={`status-icon-wrapper ${
                  statusPopup.success ? "status-success" : "status-error"
                }`}
              >
                {statusPopup.success ? (
                  <CircleCheckBig size={28} />
                ) : (
                  <CircleX size={28} />
                )}
              </div>

              {/* TEXT */}
              <div className="status-text-content">
                <h3 className="status-title">
                  {statusPopup.success
                    ? "Booking Details Updated"
                    : "Action Failed"}
                </h3>

                <p className="status-message">{statusPopup.message}</p>
              </div>
            </div>

            {/* BUTTON */}
            <div className="status-action">
              <button
                className={`status-ok-btn ${
                  statusPopup.success ? "status-ok-success" : "status-ok-error"
                }`}
                onClick={() => {
                  setStatusPopup({
                    open: false,
                    success: false,
                    message: "",
                  });

                  setOpenRejectPopup(false);

                  onClose();
                }}
              >
                {statusPopup.success ? "Okay" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
